import { type PageType } from '@blaze-shared/api-contracts-domain';

export const PAGE_TYPES_SUPPORTING_PAGE_CONTEXT: PageType[] = ['Page', 'Dialog', 'Drawer'];
